import FormAsignacionPresupuestoAreas from "./Form"

export default function EditarAreaPresup() {
    return (
        <>
            <FormAsignacionPresupuestoAreas data={JSON.parse(localStorage.getItem("preuniejearea"))}/>
        </>
    )
}